import React, { useEffect, useState } from 'react';
import MediaQuery from 'react-responsive';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Configs from 'config';
import { get } from 'lodash';
import MentorCard from 'components/mentoring/mentor/MentorCard';
import { MentoringReview, MentoringPassCase } from 'components/mentoring/MentoringCreditPrice';
import FrameworkInfoModal from 'components/modal/FrameworkInfoModal';
import OpenKakaoModal from 'components/modal/OpenKakaoModal';
import { getMentorsForLanding } from 'libs/api/user';
import { useDataApi, usePagination } from 'libs/hooks';
import { TListResponse, TPagination } from 'modules/types';
import { TSimpleMentor } from 'modules/user';
import { CWindowWidth } from 'constants/base.const';
import { ERoute } from 'enums/route.enum';
import { Col, Row, Typography, Button, List } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, LightGrayColor, device, size } from 'GlobalStyles';
import blueStar from 'assets/icons/blueStar.webp';
import BackgroundBottomSource from 'assets/images/banners/10.webp';
import BackgroundSource from 'assets/images/banners/2.webp';
import BainLogoSource from 'assets/images/logos/bain.svg';
import BCGLogoSource from 'assets/images/logos/bcg.svg';
import McKinseyLogoSource from 'assets/images/logos/mckinsey.svg';
import HeaderImg1 from 'assets/images/pages/landing/headerImg1.webp';
import HeaderImg2 from 'assets/images/pages/landing/headerImg2.webp';
import HeaderImg3 from 'assets/images/pages/landing/headerImg3.webp';
import exerciseNum from 'assets/images/pages/landing/icons/exerciseNum.webp';
import mentoringNum from 'assets/images/pages/landing/icons/mentoringNum.webp';
import mentorNum from 'assets/images/pages/landing/icons/mentorNum.webp';
import nextBtn from 'assets/images/pages/landing/icons/nextBtn.svg';
import person from 'assets/images/pages/landing/icons/person.webp';
import prevBtn from 'assets/images/pages/landing/icons/prevBtn.svg';
import stair from 'assets/images/pages/landing/icons/stair.webp';
import Introduction1 from 'assets/images/pages/landing/introduction1.webp';
import Introduction2 from 'assets/images/pages/landing/introduction2.webp';
import Introduction3 from 'assets/images/pages/landing/introduction3.webp';
import Introduction4 from 'assets/images/pages/landing/introduction4.webp';
import Introduction5 from 'assets/images/pages/landing/introduction5.webp';
import Introduction6 from 'assets/images/pages/landing/introduction6.webp';
import Introduction7 from 'assets/images/pages/landing/introduction7.webp';
import 'animate.css/animate.min.css';

const { Text, Title } = Typography;
const COMPANYLOGO = [BCGLogoSource, McKinseyLogoSource, BainLogoSource];
const HEADERIMGS = [
  { link: HeaderImg1, textTop: '전략 컨설팅', textBottom: 'Frameworks와 이론' },
  {
    link: HeaderImg2,
    textTop: 'Case interview',
    textBottom: '기출문제 연습 tool',
  },
  { link: HeaderImg3, textTop: '1:1', textBottom: 'Mock interview' },
];
const PASSMEMBERCOUNT: Array<TCountForLanding> = [
  { title: `MBB 합격자 수`, count: 82 },
  {
    title: `전체 컨설팅펌 합격자 수`,
    count: 136,
    extra: '*Last Updated - 2024년 7월',
  },
];
const STAIRINTRODUCTION = [
  {
    title: '이해하기',
    topText: 'Frameworks 설명글을 읽고 케이스 문제를 풀어보세요.',
    bottomText: '누구의 도움 없이도 컨설팅 인터뷰에 대한 이해를 100%로 만들 수 있습니다.',
    className: 'oneStep',
  },
  {
    title: '연습하기',
    topText: '실전 같은 Mock 인터뷰 보다 더 좋은 연습은 없습니다.',
    bottomText: '국내 최고 멘토진과의 멘토링으로 연습하세요.',
    className: 'twoStep',
  },
  {
    title: '실전으로!',
    topText: '모든 준비는 끝났습니다.',
    bottomText: '그 동안의 이해도와 경험치를 실전에서 보여주세요!',
    className: 'threeStep',
  },
];

type TCountForLanding = {
  title: string;
  count: number;
  img?: string;
  extra?: string;
};
interface IBackGround {
  bg?: string;
}

const Landing = () => {
  const [countForLanding, setCountForLanding] = useState<Array<TCountForLanding>>();

  const handleCountForLanding = async () => {
    const { data } = await axios.get(`${Configs.API_HOST}/mentoring/mentor_count_for_landing`);

    const countForPage = [
      {
        title: 'Top tier 컨설팅 회사 출신 멘토 수',
        count: data?.mentor,
        img: mentorNum,
      },
      { title: '총 멘토링 횟수', count: data?.mentoring, img: mentoringNum },
      {
        title: '실전 케이스 연습문제 수',
        count: data?.exercise_quiz,
        img: exerciseNum,
      },
    ];

    const countForLanding = [...countForPage];

    setCountForLanding(countForLanding);
  };

  useEffect(() => {
    handleCountForLanding();
  }, []);

  return (
    <LandingWrapper>
      {/* <OpenKakaoModal /> */}
      <FrameworkInfoModal />
      <TopBanner>
        <div className='container'>
          {COMPANYLOGO.map((logo) => (
            <CompanyLogo src={logo} />
          ))}
          <Title>
            <span className='lineBreak'>MBB 출신이 만든</span> All in one 컨설팅 취업준비 플랫폼
          </Title>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text className='subTitle'>
              Career Step은 글로벌 Consulting Firm 입사를 위한 개인 맞춤형 온라인 멘토링 플랫폼 입니다
            </Text>
            <Text className='subTitle'>
              프로그램 소개 페이지를 통해 글로벌 Finance Firm 입사를 위한 멘토링 프로그램도 확인해보세요
            </Text>
          </div>
          <Row className='topImg' gutter={[16, 16]} style={{ transform: 'translateY(60px)' }}>
            {HEADERIMGS.map(({ link, textTop, textBottom }: any) => (
              <Col md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                <TopImg bg={link}>
                  {textTop}
                  <br />
                  {textBottom}
                </TopImg>
              </Col>
            ))}
          </Row>
        </div>
      </TopBanner>

      <ResponsiveRow>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Text className='subTitle'>
            Career Step은 글로벌 Consulting Firm 입사를 위한 개인 맞춤형 온라인 멘토링 플랫폼 입니다
          </Text>
          <Text className='subTitle'>
            프로그램 소개 페이지를 통해 글로벌 Finance Firm 입사를 위한 멘토링 프로그램도 확인해보세요
          </Text>
        </div>
        <TopImgs>
          {HEADERIMGS.map(({ link, textTop, textBottom }: any) => (
            <TopImg bg={link}>
              {textTop}
              <br />
              {textBottom}
            </TopImg>
          ))}
        </TopImgs>
      </ResponsiveRow>

      <SectionWrapper bg='white'>
        <div className='container'>
          <SectionHeader>
            <BlueStarIcon src={blueStar} />
            <SectionSubtitle>수많은 컨설팅 지원자가 Career Step 을 찾는 이유</SectionSubtitle>
            <SectionTitle>압도적인 합격자 수</SectionTitle>
            <img className='personIcon' alt='' src={person} />
          </SectionHeader>
          <Row gutter={[16, 16]}>
            {PASSMEMBERCOUNT?.map(({ title, count, img, extra }: any, i) => (
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }}>
                <StatisticCard bg={''}>
                  {img && <img src={img} alt={img} />}
                  <CardTitle>{title}</CardTitle>
                  <CardStatistic>
                    {count}
                    <span> 명</span>
                  </CardStatistic>
                  {extra && <UpdatedText>{extra}</UpdatedText>}
                </StatisticCard>
              </Col>
            ))}
          </Row>
          <Row gutter={[16, 16]}>
            {countForLanding?.map(({ title, count, img }: any, i) => (
              <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
                <StatisticCard bg={'white'}>
                  {img && <img src={img} alt={img} />}
                  <CardTitle>{title}</CardTitle>
                  <CardStatistic>
                    {count}
                    {i === 5 ? <span> 개</span> : i === 4 ? <span> 회</span> : <span> 명</span>}
                  </CardStatistic>
                </StatisticCard>
              </Col>
            ))}
          </Row>
        </div>
      </SectionWrapper>

      <MediaQuery minWidth={size.lg + 1}>
        <SectionWrapper bg='gray'>
          <div className='container'>
            <BlueStarIcon src={blueStar} />
            <MentoringPassCase reviewNum={6} />
            <Col md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }} style={{ margin: '0 auto' }}>
              <Link to={`${ERoute.IntroductionReview}/pass_review`}>
                <Button style={{ display: 'block', width: '100%', marginTop: '30px' }} type='primary'>
                  합격 사례 더보기
                </Button>
              </Link>
            </Col>
          </div>
        </SectionWrapper>
      </MediaQuery>
      <MediaQuery maxWidth={size.lg}>
        <SectionWrapper bg='gray'>
          <BlueStarIcon src={blueStar} />
          <MentoringPassCase reviewNum={3} />
          <Col xs={{ span: 24 }} sm={{ span: 24 }}>
            <Link to={`${ERoute.IntroductionReview}/pass_review`}>
              <Button style={{ display: 'block', width: '100%' }} type='primary'>
                합격 사례 더보기
              </Button>
            </Link>
          </Col>
        </SectionWrapper>
      </MediaQuery>

      <SectionWrapper bg='white'>
        <div className='container'>
          <SectionHeader style={{ alignItems: 'start' }}>
            <BlueStarIcon style={{ margin: '0' }} src={blueStar} />
            <SectionTitle>
              <div className='strongText'>Career Step 의</div>
              All in one 컨설팅 준비과정
            </SectionTitle>
          </SectionHeader>
          <SectionBody style={{ alignItems: 'end' }}>
            <Introduction>
              {STAIRINTRODUCTION.map(({ title, topText, bottomText }: any) => (
                <>
                  <IntroductionTitle>{title}</IntroductionTitle>
                  <IntroductionText>
                    <span className='lineBreak'>{topText}</span>
                    {bottomText}
                  </IntroductionText>
                </>
              ))}
            </Introduction>

            <StairImg>
              {STAIRINTRODUCTION.map(({ title, className }: any) => (
                <div className={`textBox ${className}`}>
                  <div>{title}</div>
                </div>
              ))}
              <img alt='stairImg' src={stair} />
            </StairImg>
          </SectionBody>
        </div>
      </SectionWrapper>

      <SectionWrapper bg='gray'>
        <div className='container'>
          <SectionHeader style={{ alignItems: 'end' }}>
            <BlueStarIcon style={{ margin: '0' }} src={blueStar} />
            <SectionTitle style={{ textAlign: 'end' }}>
              컨설팅 인터뷰
              <div className='strongText'>이해하기</div>
            </SectionTitle>
          </SectionHeader>
          <Row gutter={[60, 60]}>
            <Col md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <IntroductionCard>
                <img alt='' src={Introduction2} />
                <SectionTitle style={{ marginTop: '25px' }}>Frameworks</SectionTitle>
                <p>
                  케이스 인터뷰 준비를 위해 꼭 알아야 하는 Frameworks 설명글을 정리했습니다. 기초 지식이
                  없어도 쉽게 읽고 케이스에 대한 이해도를 올릴 수 있습니다.
                </p>
              </IntroductionCard>
            </Col>
            <Col md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <IntroductionCard>
                <img alt='' src={Introduction1} />
                <SectionTitle style={{ marginTop: '25px' }}>케이스 문제</SectionTitle>
                <p>
                  때로는 읽고 기억하는 것만으로는 충분하지 않을 수 있습니다. 실전 케이스와 유사한 케이스
                  문제를 풀고 케이스를 여러분의 것으로 만드세요.
                </p>
              </IntroductionCard>
            </Col>
          </Row>
        </div>
      </SectionWrapper>

      <SectionWrapper>
        <div className='container'>
          <SectionHeader style={{ alignItems: 'start' }}>
            <BlueStarIcon style={{ margin: '0' }} src={blueStar} />
            <SectionTitle style={{ color: '#003159' }}>
              컨설팅 인터뷰
              <div style={{ color: SecondaryColor }}>연습하기</div>
            </SectionTitle>
          </SectionHeader>
          <Row gutter={[60, 60]} style={{ justifyContent: 'end' }}>
            <Col md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <IntroductionCard>
                <img alt='' src={Introduction4} />
                <SectionTitle style={{ marginTop: '25px' }}>1:1 멘토링</SectionTitle>
                <p>
                  Top tier 컨설팅 회사 출신의 멘토를 1:1 로 만나보세요. 케이스 인터뷰 기초부터 실전 대비 Mock
                  인터뷰까지 모든 것이 가능합니다.
                </p>
              </IntroductionCard>
            </Col>
            <Col md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <IntroductionCard>
                <img alt='' src={Introduction3} />
                <SectionTitle style={{ marginTop: '25px' }}>케이스 노트</SectionTitle>
                <p>
                  케이스 인터뷰 전문 멘토들이 직접 풀이한 케이스 문제입니다. 멘토만의 합격 노하우와 실전용 Tip
                  을 생생하게 느껴보세요.
                </p>
              </IntroductionCard>
            </Col>
          </Row>
        </div>
      </SectionWrapper>

      <MediaQuery minWidth={size.md + 1}>
        <PopularMentors />
      </MediaQuery>
      <MediaQuery minWidth={size.sm + 1} maxWidth={size.md}>
        <PopularMentors count={2} />
      </MediaQuery>
      <MediaQuery maxWidth={size.sm}>
        <PopularMentors count={1} />
      </MediaQuery>

      <MediaQuery minWidth={size.lg + 1}>
        <SectionWrapper bg='white'>
          <div className='container'>
            <img
              className='starIcon'
              alt=''
              src={blueStar}
              style={{ width: '15px', display: 'block', margin: '0 auto 10px auto' }}
            />
            <MentoringReview reviewNum={6} />
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 24 }}
              lg={{ span: 8 }}
              xl={{ span: 8 }}
              style={{ margin: '0 auto' }}
            >
              <Link to={`${ERoute.IntroductionReview}/mentoring_review`}>
                <Button style={{ display: 'block', width: '100%' }} type='primary'>
                  후기 더보기
                </Button>
              </Link>
            </Col>
          </div>
        </SectionWrapper>
      </MediaQuery>
      <MediaQuery maxWidth={size.lg}>
        <SectionWrapper bg='white'>
          <BlueStarIcon src={blueStar} />
          <MentoringReview reviewNum={3} />
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
            <Link to={`${ERoute.IntroductionReview}/mentoring_review`}>
              <Button style={{ display: 'block', width: '100%' }} type='primary'>
                후기 더보기
              </Button>
            </Link>
          </Col>
        </SectionWrapper>
      </MediaQuery>

      {/* <SectionWrapper bg='gray'>
        <div className='container'>
          <SectionHeader style={{ alignItems: 'center' }}>
            <BlueStarIcon src={blueStar} />
            <SectionTitle style={{ color: '#003159' }}>
              Career Step 회원에게만 제공되는 더 많은 서비스를 만나보세요
            </SectionTitle>
          </SectionHeader>
          <Row gutter={[16, 16]} style={{ marginTop: '55px' }}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <IntroductionCard style={{ textAlign: 'center' }}>
                <img alt='' src={Introduction7} />
                <SectionTitle style={{ marginTop: '15px', fontSize: '20px' }}>
                  가장 빠른 정규직/RA 채용공고
                </SectionTitle>
              </IntroductionCard>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <IntroductionCard style={{ textAlign: 'center' }}>
                <img alt='' src={Introduction6} />
                <SectionTitle style={{ marginTop: '15px', fontSize: '20px' }}>
                  합격 확률 진단 대시보드
                </SectionTitle>
              </IntroductionCard>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 8 }} xl={{ span: 8 }}>
              <IntroductionCard style={{ textAlign: 'center' }}>
                <img alt='' src={Introduction5} />
                <SectionTitle style={{ marginTop: '15px', fontSize: '20px' }}>
                  회사별 최신 뉴스 업데이트
                </SectionTitle>
              </IntroductionCard>
            </Col>
          </Row>
        </div>
      </SectionWrapper> */}
      <BottomWrapper>
        <div className='innerBox'>
          <Title className='title' style={{ marginBottom: '5px', color: '#003159' }}>
            Career Step 회원가입하기
          </Title>
          <div style={{ marginTop: '10px' }}>
            <Link to={ERoute.UserSignup}>
              <Button type='primary'>회원가입</Button>
            </Link>
          </div>
        </div>
      </BottomWrapper>
    </LandingWrapper>
  );
};

const PopularMentors = ({ count }: { count?: number }) => {
  const numOfCard = count ? count : 4;
  const [pagination, setPagination] = usePagination(numOfCard);

  const reloadPage = (page?: Partial<TPagination>) => {
    setPagination({
      ...pagination,
      ...page,
    });
  };

  const getPromise = getMentorsForLanding.bind(null, {
    params: {
      current: pagination.current,
      pageSize: pagination.pageSize,
      mentoringField: pagination.mentoringField,
    },
  });
  const [{ data, loading }, setCallback] = useDataApi<TListResponse<TSimpleMentor>>(getPromise, {
    contents: [],
    last: false,
  });

  useEffect(() => {
    setCallback(() => getPromise);
  }, [pagination]);

  return (
    <GrayBackgroundWrapper>
      <div
        style={{
          maxWidth: `${maxWidth}px`,
          margin: 'auto',
          padding: '50px 20px',
        }}
      >
        <SectionHeader style={{ alignItems: 'center', marginBottom: '50px' }}>
          <img className='starIcon' alt='' src={blueStar} />
          <SectionTitle>
            인기 <span className='strongText'>멘토</span>
          </SectionTitle>
        </SectionHeader>
        <List
          loading={{ spinning: loading, delay: 1000 }}
          grid={{ gutter: 32, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }}
          dataSource={get(data, 'contents')}
          renderItem={(item) => (
            <List.Item>
              <MentorCard userTagColor={PrimaryColor} mentor={item} style={{ margin: 'auto' }} />
            </List.Item>
          )}
        />
        <Row justify='space-between' align='middle' style={{ maxWidth: maxWidth }}>
          <PrevBtn
            onClick={() =>
              reloadPage({
                current: Number(pagination.current) > 1 ? Number(pagination.current) - 1 : 1,
                pageSize: pagination.pageSize,
              })
            }
          >
            <img alt='' src={prevBtn} />
          </PrevBtn>

          <div style={{ color: '#747474' }}>
            {pagination.current}/{Math.ceil(get(data, 'total') / Number(pagination.pageSize))}
          </div>

          <NextBtn
            onClick={() =>
              reloadPage({
                current:
                  Number(pagination.current) < Math.ceil(get(data, 'total') / Number(pagination.pageSize))
                    ? Number(pagination.current) + 1
                    : Math.ceil(get(data, 'total') / Number(pagination.pageSize)),
                pageSize: pagination.pageSize,
              })
            }
          >
            <img alt='' src={nextBtn} />
          </NextBtn>
        </Row>
      </div>
    </GrayBackgroundWrapper>
  );
};

export default Landing;

const maxWidth = CWindowWidth - 200;
const LandingWrapper = styled.div`
  max-width: ${maxWidth};
  word-break: keep-all;
`;

const TopBanner = styled.section`
  width: 100%;
  margin-bottom: 125px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.3)),
    linear-gradient(360deg, #ffffff 0%, rgba(255, 255, 255, 0) 40.9%),
    linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 20.03%),
    linear-gradient(90deg, #ffffff 15.07%, rgba(255, 255, 255, 0.5625) 61.52%, rgba(255, 255, 255, 0) 100%),
    url(${BackgroundSource});
  background-size: cover;

  @media screen and ${device.lg} {
    margin-bottom: 10px;
  }

  .container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 50px;

    @media screen and ${device.lg} {
      padding: 20px;
      padding-bottom: 0;
    }
  }

  .ant-typography {
    margin-bottom: 20px;
    font-size: 32px;
    color: ${PrimaryColor};

    @media screen and ${device.lg} {
      font-size: 18px;
    }

    .lineBreak {
      @media screen and ${device.lg} {
        display: block;
      }
    }
  }

  .subTitle {
    display: inline-block;
    width: 534px;
    font-size: 18px;

    @media screen and ${device.lg} {
      display: none;
    }
  }

  .topImg {
    @media screen and ${device.lg} {
      display: none;
    }
  }
`;

const CompanyLogo = styled.img`
  height: 30px;
  margin: 135px 30px 20px 0;

  @media screen and ${device.lg} {
    height: 18px;
    margin: 110px 10px 10px 0;
  }
`;

const GrayBackgroundWrapper = styled.div`
  padding: 0px 5px;
  background: ${LightGrayColor};
  color: #14112a;
  overflow: hidden;

  .paper1 {
    width: 100%;
    height: 650px;
    background: ${SecondaryColor};
  }
  .paper2 {
    width: 100%;
    height: 750px;
    background: ${PrimaryColor};
  }
  .ant-form-item {
    margin-bottom: 8px;
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }
  .ant-pagination {
    text-align: left;
    margin: 16px 0px !important;
  }
  .ant-pagination-item {
    display: none;
  }
`;

const BottomWrapper = styled.div`
  width: 100%;
  height: 220px;
  padding: 70px 10px;
  background-image: url(${BackgroundBottomSource});
  background-size: cover;

  .innerBox {
    display: block;
    max-width: ${maxWidth}px;
    width: 100%;
    margin: auto;

    .ant-typography {
      color: #ffffff;
    }

    .ant-typography.title {
      @media screen and ${device.lg} {
        font-size: 24px;
      }
    }
  }
`;

const TopImg = styled.div<IBackGround>`
  display: flex;
  justify-content: end;
  align-items: end;
  height: 152px;
  padding: 16px 22px;
  font-size: 20px;
  border-radius: 6px;
  color: #ffffff;
  line-height: 28px;
  text-align: right;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), ${({ bg }) => `url(${bg})`};
  background-size: cover;

  @media screen and ${device.lg} {
    flex-shrink: 0;
    width: 150px;
    height: 135px;
    margin-right: 10px;
    padding: 10px 12px;
    font-size: 12px;
    line-height: 16px;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${PrimaryColor};

  .starIcon {
    width: 15px;
    margin-bottom: 10px;
  }

  .personIcon {
    width: 44px;
    margin: 16px 0 11px 0;

    @media screen and ${device.lg} {
      width: 36px;
    }
  }

  .strongText {
    color: ${SecondaryColor};
  }
`;

const SectionTitle = styled.div`
  font-size: 24px;
  font-weight: 700;

  @media screen and ${device.lg} {
    font-size: 20px;
  }
`;

const SectionSubtitle = styled.div`
  margin-bottom: 3px;
  font-size: 13px;
`;

const StatisticCard = styled.div<IBackGround>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0 10px 0;
  border: ${({ bg }) => (bg === 'white' ? '2px solid #e4e4e4' : 'none')};
  border-radius: 10px;
  color: ${PrimaryColor};
  background-color: ${({ bg }) => (bg === 'white' ? '#ffffff' : '#f9f9f9')};

  img {
    height: 34px;
    margin-bottom: 13px;
  }
`;

const CardTitle = styled.div`
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 700;

  @media screen and ${device.lg} {
    font-size: 14px;
  }
`;

const CardStatistic = styled.div`
  font-size: 56px;
  font-weight: 700;
  color: #3cac40;

  @media screen and ${device.lg} {
    font-size: 36px;
  }

  span {
    font-size: 18px;

    @media screen and ${device.lg} {
      font-size: 14px;
    }
  }
`;

const SectionWrapper = styled.div<IBackGround>`
  padding: 60px 0;
  background-color: ${({ bg }) =>
    bg === 'white' ? '#ffffff' : bg === 'gray' ? '#f9f9f9' : bg === 'green' ? '#3cac40' : ''};

  @media screen and ${device.lg} {
    padding: 40px 20px;
  }

  .container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 50px;

    @media screen and ${device.lg} {
      padding: 0;
    }
  }
`;

const SectionBody = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;

  @media screen and ${device.lg} {
    flex-direction: column;
  }
`;
const Introduction = styled.div`
  width: 50%;

  @media screen and ${device.lg} {
    width: 100%;
    order: 2;
  }
`;

const IntroductionTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #003159;

  @media screen and ${device.lg} {
    font-size: 18px;
  }
`;

const IntroductionText = styled.p`
  margin-bottom: 30px;
  font-size: 18px;
  color: #14112a;

  @media screen and ${device.lg} {
    font-size: 14px;
  }

  .lineBreak {
    display: block;

    @media screen and ${device.lg} {
      display: inline;
    }
  }
`;

const IntroductionCard = styled.div`
  /* margin-right: 16px; */

  @media screen and ${device.lg} {
    margin: 25px 0 0 0;
  }

  img {
    width: 100%;
  }

  p {
    margin-top: 10px;
    font-size: 18px;

    @media screen and ${device.lg} {
      margin-top: 5px;
      font-size: 14px;
    }
  }
`;

const ResponsiveRow = styled.div`
  display: none;
  padding: 0 20px;

  @media screen and ${device.lg} {
    display: block;
  }

  .subTitle {
    display: inline-block;
    margin-bottom: 50px;
    color: #003159;

    &:first-child {
      margin-bottom: 20px;
    }
  }
`;

const TopImgs = styled.div`
  display: flex;
  overflow-x: auto;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const StairImg = styled.div`
  position: relative;
  width: min(46vw, 800px);

  @media screen and ${device.lg} {
    width: 100%;
    margin-top: 15px;
    margin-bottom: 30px;
    order: 1;
  }

  .textBox {
    position: absolute;
    font-size: min(1.4vw, 24px);
    color: ${PrimaryColor};
    text-align: end;

    @media screen and ${device.lg} {
      font-size: 3.6vw;
    }
  }

  .oneStep {
    top: 75%;
    left: 11%;

    @media screen and ${device.lg} {
      top: 74%;
      left: 8%;
    }
  }

  .twoStep {
    top: 54%;
    left: 26%;

    @media screen and ${device.lg} {
      top: 53%;
      left: 23%;
    }
  }

  .threeStep {
    top: 32%;
    left: 41%;

    @media screen and ${device.lg} {
      left: 38%;
    }
  }

  img {
    width: 100%;
  }
`;

const PrevBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  background-color: #ffffff;
`;

const NextBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  cursor: pointer;
  background-color: #ffffff;
`;

const BlueStarIcon = styled.img`
  display: block;
  margin: 0 auto;
  width: 15px;
  margin-bottom: 10px;
`;

const UpdatedText = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-weight: 700;
  color: #747474;
  font-size: 14px;
`;
